import * as Yup from 'yup';

export const SchemaProfileIngJobAccount = Yup.object().shape({
	/*job: Yup.string()
		.required('Veuillez renseigner votre poste'),*/
	signature: Yup.string()
		.required('Veuillez renseigner votre signature'),
	workingRegion: Yup.string(),
})